import React from 'react';
import { useThemeContext } from '../../DynamicThemeContext';

/**
 * The question card is a sheet of warm vellum laid on the book: the shared frosted glass takes a cream tint and a
 * hairline of gold, so the card belongs to the book. The rules apply only under this theme's own scope and only
 * to the card surface. Over the closed cover (the first card and the finale) the vellum is a little more opaque.
 */
const cardSkin = (alpha: number) => `
.flow-theme-scope[data-flow-theme='life_plan'][data-flow-card-glass] [data-flow-surface='card'] {
  background-color: rgba(251, 245, 229, ${alpha});
  box-shadow:
    0 28px 64px -30px rgba(18, 8, 0, 0.7),
    inset 0 1px 0 rgba(255, 246, 220, 0.85),
    inset 0 0 0 1px rgba(201, 150, 46, 0.4);
}
`;

export const LifePlanOverlay: React.FC = () => {
  const { content, progress } = useThemeContext();
  const closedCover = content.activity?.key === 'lp_0002' || (progress.complete && content.module.number === 20);
  return <style data-testid="life-plan-card-skin">{cardSkin(closedCover ? 0.9 : 0.78)}</style>;
};
